import { useAuthStateStore, usePublicProgressStateStore, } from '@annunciate/core';
import { request } from '../request';
import { PROGRESS_GET } from '../queries';
export const fetchRecentProgress = async (client) => {
    const uuid = useAuthStateStore.getState().getUUID(true);
    if (uuid === 'public') {
        return usePublicProgressStateStore.getState().progress;
    }
    const progressKey = `progress`;
    let mostRecentUpdatedAt;
    let existingProgressQuery = client.getQueryData([progressKey]);
    if (existingProgressQuery) {
        existingProgressQuery = existingProgressQuery.filter(p => p.uuid === uuid);
        existingProgressQuery.forEach((item) => {
            if (!item.updatedAt)
                return;
            const itemUpdatedAt = new Date(item.updatedAt);
            if (!mostRecentUpdatedAt) {
                mostRecentUpdatedAt = itemUpdatedAt;
            }
            else if (mostRecentUpdatedAt < itemUpdatedAt) {
                mostRecentUpdatedAt = itemUpdatedAt;
            }
        });
    }
    return client.fetchQuery({
        queryKey: [progressKey],
        queryFn: async () => {
            let variables;
            if (mostRecentUpdatedAt) {
                variables = {
                    filter: {
                        updated_at_gte: mostRecentUpdatedAt.toISOString(),
                    },
                };
            }
            try {
                const result = await request({
                    query: PROGRESS_GET,
                    variables,
                });
                if (result?.errors) {
                    throw new Error('An unknown error occurred fetching recent progress. Please contact support.');
                }
                return result?.progress;
            }
            catch (err) {
                const errors = err?.response?.errors || [];
                if (errors[0]?.extensions?.code === 'UNAUTHENTICATED') {
                    return [];
                }
                else {
                    throw err;
                }
            }
        },
        gcTime: Infinity,
        staleTime: 0,
    });
};
//# sourceMappingURL=fetchRecentProgress.js.map